import { ServiceForm, ServicePage } from '../../shared'
import { submitContactUpdation } from '../api/contactUpdation.service'

export function ContactUpdation() {
  return (
    <ServicePage current="contact">
      <ServiceForm
        includeName
        includeContact
        issuerKind="listing"
        selectPlaceholder="*** CHOOSE ***"
        resetOnSuccess
        onSubmitRequest={submitContactUpdation}
      />
    </ServicePage>
  )
}
